import { useQuery } from '@tanstack/react-query';
import { getTeamUsageDetails } from '../../api/queries';

enum CacheKey {
  TeamUsageDetails = 'TeamUsageDetails',
}

export const useGetTeamUsageDetailsQuery = (
  teamId: string,
  periodStart?: string,
  periodEnd?: string,
) => {
  return useQuery({
    queryKey: [CacheKey.TeamUsageDetails, teamId, periodStart, periodEnd],
    queryFn: () => getTeamUsageDetails(teamId, periodStart, periodEnd),
    enabled: !!teamId,
  });
};
